import { render, staticRenderFns } from "./VueIconPicker.vue?vue&type=template&id=10930182&"
import script from "./VueIconPicker.vue?vue&type=script&lang=js&"
export * from "./VueIconPicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports